import React from "react";

const ComparisonTable = ({ plans }) => {
  // Unique feature list across all plans
  const allFeatures = Array.from(
    new Set(plans.flatMap(plan => plan.features.map(f => f.text)))
  );

  return (
    <div className="overflow-x-auto rounded-xl border border-border">
      <table className="w-full text-sm">
        <thead className="bg-muted">
          <tr>
            <th className="text-left p-4 font-semibold">Features</th>
            {plans.map(plan => (
              <th
                key={plan._id}
                className="text-center p-4 font-semibold"
              >
                {plan.name}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {allFeatures.map(feature => (
            <tr key={feature} className="border-t">
              <td className="p-4">{feature}</td>

              {plans.map(plan => {
                const included = plan.features.find(
                  f => f.text === feature
                )?.included;

                return (
                  <td key={plan._id} className="text-center">
                    {included ? "✅" : "—"}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ComparisonTable;
